import { X } from 'lucide-react';

import LinkedProfileTabbedView from './LinkedProfileTabbedView';

type Props = {
  ticketId: string;
  currentTicketId?: string;
  linkedLearnerId?: string | null;
  linkedLearnerName?: string | null;
  linkedEnrollmentId?: string | null;
  onClose: () => void;
};

export default function LinkedProfileFullPanel({
  ticketId,
  currentTicketId,
  linkedLearnerId,
  linkedLearnerName,
  linkedEnrollmentId,
  onClose,
}: Props) {
  return (
    <>
      <button
        type="button"
        className="overlay"
        aria-label="Close profile panel"
        onClick={onClose}
      />
      <aside className="slide-over" role="dialog" aria-modal="true" aria-label="Customer profile">
        <div className="slide-over-header">
          <h2>Customer profile</h2>
          <button type="button" className="icon-btn" onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>
        <LinkedProfileTabbedView
          ticketId={ticketId}
          currentTicketId={currentTicketId}
          linkedLearnerId={linkedLearnerId}
          linkedLearnerName={linkedLearnerName}
          linkedEnrollmentId={linkedEnrollmentId}
          onTicketNavigate={onClose}
        />
      </aside>
    </>
  );
}
